export const PhoneNumberCode = ({ code }) => <div className='bg-secondaryBackground text-sm font-[400] text-black-400'>{code}</div>
